function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(1 1)"
}, React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}, React.createElement("path", {
  d: "M65.072 32.494a12.348 12.348 0 00-2.52-3.895 11.822 11.822 0 00-3.73-2.633A11.226 11.226 0 0054.263 25H45.733c-1.613 0-3.154.346-4.557.966a11.81 11.81 0 00-3.728 2.633 12.309 12.309 0 00-2.523 3.895A12.617 12.617 0 0034 37.25c0 1.685.33 3.294.925 4.756a12.278 12.278 0 002.523 3.895 11.768 11.768 0 003.728 2.633 11.19 11.19 0 004.557.966H54.264c1.616 0 3.155.346 4.557.966a11.822 11.822 0 013.731 2.633 12.348 12.348 0 012.52 3.895c.597 1.465.928 3.07.928 4.756 0 1.685-.33 3.291-.928 4.756a12.317 12.317 0 01-2.52 3.895 11.822 11.822 0 01-3.73 2.633c-1.403.62-2.942.966-4.558.966H45.733c-1.613 0-3.154-.346-4.557-.966a11.81 11.81 0 01-3.728-2.633 12.278 12.278 0 01-2.523-3.895",
  className: "no-payouts-stroke"
}), React.createElement("path", {
  d: "M49.5 20v60",
  className: "no-payouts-stroke"
}), React.createElement("path", {
  d: "M28.287 30.787l42.426 42.426",
  className: "no-payouts-stroke"
}), React.createElement("path", {
  stroke: "#FFF",
  d: "M28.287 27.787l42.426 42.426"
})), React.createElement("circle", {
  cx: 50,
  cy: 50,
  r: 50,
  strokeWidth: 2,
  className: "no-payouts-stroke"
}));

var SvgIconNoPayouts = function SvgIconNoPayouts(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 102,
    height: 102,
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconNoPayouts, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-no-payouts.e9aae78e.svg";
export { ForwardRef as ReactComponent };